/**
 * Tracks the previous in-app route and the most recent /work URL the user
 * visited in this session. Backed by sessionStorage so it survives soft
 * navigations but resets per tab.
 */

const PREV_KEY = "lastRoute:previous";
const WORK_KEY = "lastRoute:work";

const storage = (): Storage | null => {
  try {
    return typeof window !== "undefined" ? window.sessionStorage : null;
  } catch {
    return null;
  }
};

export const setPreviousRoute = (route: string): void => {
  const s = storage();
  if (!s) return;
  try {
    s.setItem(PREV_KEY, route);
  } catch {
    /* ignore quota */
  }
};

export const getPreviousRoute = (): string | null => {
  const s = storage();
  if (!s) return null;
  try {
    return s.getItem(PREV_KEY);
  } catch {
    return null;
  }
};

export const setLastWorkUrl = (url: string): void => {
  const s = storage();
  if (!s) return;
  try {
    s.setItem(WORK_KEY, url);
  } catch {
    /* ignore quota */
  }
};

export const getLastWorkUrl = (): string | null => {
  const s = storage();
  if (!s) return null;
  try {
    return s.getItem(WORK_KEY);
  } catch {
    return null;
  }
};
